import { render, staticRenderFns } from "./AlarmTableOverview.vue?vue&type=template&id=518bc124&"
import script from "./AlarmTableOverview.vue?vue&type=script&lang=ts&"
export * from "./AlarmTableOverview.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmTableOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports